<script lang="ts">
	import Blok from '$lib/storyblok/blok.svelte';
	import { useStoryblokBridge } from '@storyblok/js';
	import { onMount } from 'svelte';

	let { data } = $props();

	onMount(() => {
		useStoryblokBridge(data.story.id, (newStory) => (data.story = newStory), {});
	});
</script>

<div
	class="bg-white transition-padding"
	style="padding-top: calc(var(--header-height) + var(--banner-height))"
>
	<Blok content={data.story.content} />
</div>
